module.exports = __webpack_public_path__ + "static/img/icon-document.3832319.png";